<template>
  <section id="step-one">
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-col cols="10" align="center">
          <v-row align="center" justify="center" class="mt-5">
            <v-col cols="12" md="12" justify="center">
              <h4 class="font-weight-bold display-2 mt-3 mb-3">
                Step 1: Plans
              </h4>
            </v-col>
          </v-row>
          <!-- line A -->
          <v-row class="text-center mb-3">
            <v-col
              lg="4"
              xs="12"
              v-for="(itemS1, index) in lineA"
              :key="'A' + index"
            >
              <div>
                <v-avatar color="deep-purple darken-3" size="35" class="mb-2">
                  <span class="white--text text-h6">{{ itemS1.no }}</span>
                </v-avatar>
              </div>
              <mobileframe title="Create Plans" :name="itemS1.img">
                <div>
                  <strong>{{ itemS1.title }}</strong>
                </div>
                <div class="text--primary">
                  <span v-html="itemS1.description"></span>
                </div>
              </mobileframe>
            </v-col>
          </v-row>
          <!-- line B -->
          <v-row class="text-center mb-3">
            <v-col
              lg="4"
              xs="12"
              v-for="(itemS2, index) in lineB"
              :key="'B' + index"
            >
              <div>
                <v-avatar color="deep-purple darken-3" size="35" class="mb-2">
                  <span class="white--text text-h6">{{ itemS2.no }}</span>
                </v-avatar>
              </div>
              <mobileframe title="Create Plans" :name="itemS2.img">
                <div>
                  <strong>{{ itemS2.title }}</strong>
                </div>
                <div class="text--primary">
                  <span v-html="itemS2.description"></span>
                </div>
              </mobileframe>
            </v-col>
          </v-row>
          <!-- line C -->
          <v-row class="text-center mb-3" justify="center">
            <v-col
              lg="4"
              xs="12"
              v-for="(itemS3, index) in lineC"
              :key="'C' + index"
            >
              <div>
                <v-avatar color="deep-purple darken-3" size="35" class="mb-2">
                  <span class="white--text text-h6">{{ itemS3.no }}</span>
                </v-avatar>
              </div>
              <mobileframe title="Create Plans" :name="itemS3.img">
                <div>
                  <strong>{{ itemS3.title }}</strong>
                </div>
                <div class="text--primary">
                  <span v-html="itemS3.description"></span>
                </div>
                <div
                  v-if="itemS3.no === '7'"
                  class="font-italic font-weight-light mt-2"
                >
                  <b>Tip:</b> You should already have MULTIPLE plans
                  & schedules prepared.
                </div>
                <div
                  v-if="itemS3.no === '8'"
                  class="font-italic font-weight-light mt-2"
                >
                  <b>Tip:</b> Make sure you have schedules in the Favorite
                  Schedule before your registration day.
                </div>
              </mobileframe>
            </v-col>
          </v-row>
          <div class="mb-2 text-center">
            <v-btn
              color="blue darken-4"
              dark
              @click="$vuetify.goTo('#step-two')"
            >
              Next Step
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import mobileframe from "@/components/shared/MobileFrame";
export default {
  components: {
    mobileframe,
  },
  data: () => ({
    lineA: [
      {
        no: "1",
        img: "bg-planning-01",
        title: "Start a plan",
        description: "Navigate to the <strong> “Planner” </strong> menu.",
      },
      {
        no: "2",
        img: "bg-planning-02",
        title: "Draft your plan",
        description:
          "Make a draft of your plan. A <em>draft</em> is a collection of courses. You can make as many drafts as you like.",
      },
      {
        no: "3",
        img: "bg-planning-03",
        title: "Add Courses",
        description: "Tap the plus (+) icon to add a course to your draft.",
      },
    ],
    lineB: [
      {
        no: "4",
        img: "bg-planning-04",
        title: "Select Course",
        description:
          "After tapping the plus (+) icon, choose a course from the list of available courses.",
      },
      {
        no: "5",
        img: "bg-planning-05",
        title: "Section Selection",
        description:
          "Select the sections you want and deselect the rest. Only the selected sections will be included in the generated schedules.",
      },
      {
        no: "6",
        img: "bg-planning-06",
        title: "Generate Schedule",
        description:
          'To generate schedules, tap on the <strong>"Show Schedule"</strong> button. The system will show all possibilities for the courses and sections selected.',
      },
    ],
    lineC: [
      {
        no: "7",
        img: "bg-planning-07",
        title: "Save Schedules to Favorites",
        description:
          "When you see a schedule you like, tap the heart button to save it to Favorite. To remove it from Favorite, tap the heart button again.",
      },
      {
        no: "8",
        img: "bg-planning-08",
        title: "Favorite Schedule",
        description:
          'Your favorite schedules will be shown on the "Favorite Schedule" segment on the planner screen for quick access.',
      },
    ],
  }),
};
</script>

<style scoped>
#step-one {
  background-color: #f4f7f5;
}
</style>
